import React from "react";
import { connect } from "react-redux";
import Flagship from "../../core/flagship";
import * as appActions from "../../actions/appActions";
import { Button, Divider, Input } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { Link } from "react-router";
import "../../styles/loginForm.scss";

class ResetPassword extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      usernameOrEmail: "",
      requested: false,
      requesting: false
    };

    this.submitRequest = this.submitRequest.bind(this);
  }

  componentDidMount() {
    document.title = "Reset Password";
  }

  onChange(e) {
    this.setState({
      usernameOrEmail: e.target.value
    });
  }

  submitRequest() {
    let self = this;
    this.setState(
      {
        requesting: true
      },
      function() {
        if (this.state.usernameOrEmail !== "") {
          Flagship.get(
            "request-reset/" + this.state.usernameOrEmail,
            {},
            function(response) {
              if (response.data === true) {
                Flagship.notify("Reset Requested.", "info");

                self.setState({
                  requested: true,
                  requesting: false
                });
              } else {
                Flagship.error(
                  "Could not request a password reset.",
                  self.props.routeParams.splat,
                  self.props.userId
                );
                self.setState({
                  requesting: false
                });
              }
            },
            function(err) {
              Flagship.error(
                "Could not request a password reset: " + err,
                self.props.routeParams.splat,
                self.props.userId
              );
              self.setState({
                requesting: false
              });
            }
          );
        } else {
          Flagship.error(
            "You didn't enter anything.",
            self.props.routeParams.splat,
            self.props.userId
          );
          self.setState({
            requesting: false
          });
        }
      }
    );
  }

  render() {
    if (this.state.requested === true) {
      return (
        <div id="login-form" className="fade-in">
          <div id="login-form-inner" className={"animated headShake"}>
            <h1>Flagship</h1>
            <h2 className="white-text">Check Your Email</h2>
            <p className="login-message">
              We sent a password reset email to the email address tied to your
              account, if it exists.
            </p>

            <Divider />

            <Link as={Button} to="/login" className="white-text">
              &larr; Back to Login
            </Link>
          </div>
        </div>
      );
    } else {
      return (
        <div id="login-form" className="fade-in">
          <div id="login-form-inner" className="animated headShake wider">
            <h1>Flagship</h1>
            <h2 className="white-text">Lost Your Password?</h2>
            <p className="login-message">
              Not to worry. Enter your Flagship username or email address below
              to get a reset email.
            </p>

            <div className="password-reset-field">
              <Input
                type="text"
                fluid
                label="Username or Email"
                value={this.state.usernameOrEmail || ""}
                placeholder="example@2060digital.com"
                onChange={(e, value) => this.onChange(e, value)}
              />
            </div>

            <Divider />

            {this.state.requesting !== true ? (
              <Button primary onClick={this.submitRequest}>
                Request Password Reset
              </Button>
            ) : null}
          </div>
        </div>
      );
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/views/ResetPassword.js